import { detectListContext } from './detectList';
import { generateStableKey } from './generateStableKey';

// 用于标识当前是否在列表循环上下文中
const listContextStack: string[] = [];

// 导出一个函数，用于启用自动 key 生成
function enableAutoKeys() {
  // 已经通过重写 createElement 启用了
  const originalCreateElement = globalThis.React.createElement;

  if (globalThis.React) {
    // console.log('React Auto Key generation enabled');
    // 重写 React.createElement
    // globalThis.React.createElement = function (...args: any[]) {
    //   const [type, props, ...children] = args;
    //
    //   const isInList = detectListContext();
    //
    //   // 如果是数组映射且没有 key，添加 key
    //   let newProps = props;
    //   if (isInList && props && props.key === undefined) {
    //     newProps = { ...props, key: generateKey() };
    //   }
    //
    //   // 调用原始函数并保持其返回类型
    //   return originalCreateElement(type, newProps, ...children);
    // } as typeof React.createElement;
    globalThis.React.createElement = function (...args: any[]) {
      const [type, props, ...children] = args;
      // 如果元素已有 key，直接使用原始函数
      if (props && props.key !== undefined && props.key !== null && props.key !== '') {
        return originalCreateElement(type, props, ...children);
      }

      // 检测当前元素是否在列表上下文中
      const currentContext = detectListContext();

      // 如果在列表上下文中，并且没有 key，则添加一个
      if (currentContext) {
        // 检查是否是新的列表上下文
        const isNewContext = !listContextStack.length || !listContextStack.includes(currentContext.id);
        if (isNewContext) {
          listContextStack.push(currentContext.id);
        }
        // 为了稳定性，确保每个列表项有不同的 key
        const key = generateStableKey(type, props, currentContext.id);
        if (typeof key !== 'string') console.log('createElement key error', key);
        const newProps = { ...props, key };
        return originalCreateElement(type, newProps, ...children);
      }
      return originalCreateElement(type, props, ...children);
    } as typeof globalThis.React.createElement;
  }
  // 返回一个函数，可以用于禁用自动 key 生成（恢复原始行为）
  return function disableAutoKeys() {
    globalThis.React.createElement = originalCreateElement;
    console.log('React Auto Key generation disabled');
  };
}

export default function polyfillReact() {
  if (globalThis.React) {
    // enableAutoKeys(); // 开启自动填充key值

    // 覆盖setState方法
    const originalSetState = globalThis.React.Component.prototype.setState;
    const originalSetStatePure = globalThis.React.PureComponent.prototype.setState;
    globalThis.React.PureComponent.prototype.setState = function (state, callback) {
      // @ts-ignore
      const isInConstructor = !this._reactInternals;
      const isFuncState = typeof state === 'function';
      // 判断是否在 constructor 中 - 多重判断保证准确性
      if (isInConstructor) {
        console.log('setState被拦截: constructor中setState');
        this.state = Object.assign(this.state || {}, state || {});
        // this.state = Object.assign(this.state || {}, (isFuncState ? state() : state) || {});
        return;
      }
      // 调用原始方法
      // return originalSetStatePure.call(this, isFuncState ? state : () => state, callback);
      return originalSetStatePure.call(this, state, callback);
    };
    globalThis.React.Component.prototype.setState = function (state, callback) {
      // @ts-ignore
      const isInConstructor = !this._reactInternals;
      const isFuncState = typeof state === 'function';
      if (isInConstructor) {
        console.log('setState被拦截: constructor中setState');
        this.state = Object.assign(this.state || {}, state || {});
        // this.state = Object.assign(this.state || {}, (isFuncState ? state() : state) || {});
        return;
      }
      // 调用原始方法
      // return originalSetState.call(this, isFuncState ? state : () => state, callback);
      return originalSetState.call(this, state, callback);
    };
  }
}
